<!-- DrawerCoupon.svelte -->
<script>
  import { spring } from 'svelte/motion';
  import { cubicOut } from 'svelte/easing';
  import { Popover } from 'svelte-smooth-popover';
  import html2canvas from 'html2canvas';
  import { Toaster, toast } from 'svelte-sonner';

  // import {browser, platform, isPWAInstalled} from './BrowserDetector.svelte';
  import HistogramChart from './HistogramChart.svelte';
  import LiveModal from './LiveModal.svelte';

  export let activeTab;
  export let setActiveTab;
  export let response;
  export let payload;
  // export let gameData;
  export let matches;
  export let groups;
  export let v1;
  export let vX;
  export let v2;
  export let antalTecken;
  export let insats;
  export let formatCurrencySEK;
  export let handleSubmitLive;
  export let submittedLive;
  export let responseLive;
  export let isLoading;
  export let utd;

//
  export let data = [
    { intervall: "2K-5K", "Antal rader": 100 },
    { intervall: "5K-10K", "Antal rader": 45 },
    { intervall: "10K-20K", "Antal rader": 177 },
    { intervall: "20K-50K", "Antal rader": 681 },
    { intervall: "50K-100K", "Antal rader": 1007 },
    { intervall: "100K-200K", "Antal rader": 1383 },
    { intervall: "200K-500K", "Antal rader": 2097 },
    { intervall: "500K-1M", "Antal rader": 1395 },
    { intervall: "1M-2M", "Antal rader": 964 },
    { intervall: "2M-5M", "Antal rader": 436 }
  ];
  export let distribution1X2;
  export let antalReduceradeRader;
  export let svsLink;

  let calcOdds = [0,0,0];
  let calcUtd  = [0,0,0];
  let enableCharDist = false;

  let tableContainer;
  let message = '';
  let imageURL;

  const tabs = [
    { label: 'Info' },
    { label: 'Utdelning', info: 'OBS! Utdelningen är beräknad och kan skilja sig från den verkliga utdelningen.' },
    // { label: 'Teckenfördelning' }
    // { label: '•', content: 'And this is what you see in Tab 3.' }
  ];

  let tabWidths = [];
  let containerWidth = 0;

  let showLiveModal = false;

  function downloadTableAsImage() {
    html2canvas(tableContainer).then(canvas => {
      // Convert canvas to base64 encoded image
      const image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
      
      // Create a temporary link element
      const link = document.createElement('a');
      
      // Set link's href to the base64 encoded image data
      link.href = image;
      
      // Set the download attribute with desired filename
      link.download = 'table.png';
      
      // Append link to the body (required for Firefox)
      document.body.appendChild(link);
      
      // Programmatically click the link to trigger the download
      link.click();
      
      // Remove the link from the document
      document.body.removeChild(link);
      
      message = 'Table image ready. If download doesn\'t start automatically, tap and hold the image to save.';
    }).catch(err => {
      console.error('Error generating image:', err);
      message = 'Failed to generate image. See console for details.';
    });
  }

  async function copyTableAsImage() {
    try {
      const makeImagePromise = async () => {
        const canvas = await html2canvas(tableContainer);
        return await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
    }
      
      await navigator.clipboard.write([
        new ClipboardItem({ 'image/png': makeImagePromise() })
      ]);
      toast("Kupongen kopierad som bild till urklipp!", {
          duration: 6000,
      });
    } catch (err) {
      console.error('Error copying table to clipboard:', err);
      message = 'Failed to copy table. See console for details.';
    }
  }

  let uploadedUrl = '';
  
  // Function for direct clipboard operation (for Safari via button click)
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(uploadedUrl);
      toast("Bildlänk kopierad till urklipp!", {
        duration: 6000,
      });
    } catch (err) {
      console.error('Modern clipboard failed:', err);
      
      // Fallback
      try {
        const textArea = document.createElement('textarea');
        textArea.value = uploadedUrl;
        document.body.appendChild(textArea);
        textArea.select();
        const success = document.execCommand('copy');
        document.body.removeChild(textArea);
        
        if (success) {
          toast("Bildlänk kopierad till urklipp!", {
            duration: 6000,
          });
        } else {
          toast("Kopiera länken manuellt: " + uploadedUrl, {
            duration: 10000,
          });
        }
      } catch (fallbackErr) {
        console.error('Fallback failed:', fallbackErr);
        toast("Kopiera länken manuellt: " + uploadedUrl, {
          duration: 10000,
        });
      }
    }
  };

  async function captureAndUpload() {
    try {
      const canvas = await html2canvas(tableContainer);
      
      canvas.toBlob(async (blob) => {
        const formData = new FormData();
        formData.append('file', blob, 'screenshot.png');
        
        const response = await fetch('https://img.tgc.bet/api/upload.php', {
          method: 'POST',
          body: formData
        });
        
        if (!response.ok) {
          throw new Error('Upload failed');
        }
        
        const result = await response.json();
        uploadedUrl = result.url;

        // Try immediate copy first (works in Chrome and others)
        try {
          await navigator.clipboard.writeText(result.url);
          toast("Bildlänk kopierad till urklipp!", {
            duration: 6000,
          });
        } catch (err) {
          // If it fails (Safari), show toast with copy button
          toast("Bildlänk skapad!", {
              duration: 10000,
              action: {
                label: 'Kopiera länk',
                onClick: () => handleCopy()
              }
          });
        }

        // message = result.url;
      }, 'image/png');
    } catch (error) {
      message = "Bildlänk kunde inte skapas :(";
      console.error('Error:', error);
    }
  }


  $: pillPosition = spring(0, {
    stiffness: 0.2,
    damping: 0.8,
    easing: cubicOut
  });

  $: {
    if (tabWidths[activeTab] && containerWidth) {
      const position = tabWidths.slice(0, activeTab).reduce((a, b) => a + b, 0);
      pillPosition.set(position);
    }
  }

  function openSvSLink() {
    window.open(svsLink, '_blank');
  }

  $: {
    if (response) {
      data = response.histogram;
      distribution1X2 = response.teckenfordelning;
      antalReduceradeRader = response.antalReduceradeRader;
      svsLink = response.svsLink;
      calcOdds[0] = response.minOdds[0];
      calcOdds[1] = response.medianOdds[0];
      calcOdds[2] = response.maxOdds[0];
      calcUtd[0] = response.minUtd[0];
      calcUtd[1] = response.medianUtd[0];
      calcUtd[2] = response.maxUtd[0];
      isLoading = false;  // Set loading to false when response is received
    }
  }

</script>
<Toaster position="top-center" />
<div class="tab-component">

  {#if isLoading}
    <div class="loading-screen">
      <div class="spinner"></div>
      <p>Loading...</p>
    </div>
  {:else}


	<div class="tab-container" bind:clientWidth={containerWidth}>
	  {#each tabs as tab, i}
	    <button
	      class="tab"
	      class:active={activeTab === i}
	      on:click={() => setActiveTab(i)}
	      bind:clientWidth={tabWidths[i]}
	    >
	      {tab.label}
	    </button>
	  {/each}
	  <div
	    class="pill"
	    style="transform: translateX({$pillPosition}px); width: {tabWidths[activeTab]}px;"
	  ></div>
	</div>

{#if activeTab === 0}
  <div class="content-area">
    <div class="item">
    <table class="calcUtdOdds">
      <tr>
        <th></th>
        <th>
          Utdelning
          <img src="/images/info.svg" height="10pt" alt="Info" title="Info" />
              <Popover 
                borderRadius={10}
                caretWidth={0}
                offset={10}
                caretCurveAmount={1}
                caretCurveTopAngle={-15}
                caretCurveTopStrength={0.3333}
                caretCurveBottomAngle={15}
                caretCurveBottomStrength={0.6666}
                caretSubmerge={true}
                align={"top-right"}
                alignAnchor={"top-right"}
                open={false}
                showOnHover={true}
                showOnClick={false}
                hideOnExternalClick={true}
              >
                <div class="popOverInfo">
                  Utdelningen är beräknad baserad på streckprocenten, omsättning och eventuell jackpot. Den kan skilja sig från den verkliga utdelningen.
                </div>
              </Popover>
        </th>
        <th>
          Odds för 13 rätt
          <img src="/images/info.svg" height="10pt" alt="Info" title="Info" />
              <Popover 
                borderRadius={10}
                caretWidth={0}
                offset={10}
                caretCurveAmount={1}
                caretCurveTopAngle={-15}
                caretCurveTopStrength={0.3333}
                caretCurveBottomAngle={15}
                caretCurveBottomStrength={0.6666}
                caretSubmerge={true}
                align={"top-right"}
                alignAnchor={"top-right"}
                open={false}
                showOnHover={true}
                showOnClick={false}
                hideOnExternalClick={true}
              >
                <div class="popOverInfo">
                  Oddsberäkningen är baserad på svenska spels odds omräknade till sannolikheter
                </div>
                  </Popover>
        </th>
      </tr>
      <tr>
        <td>Min</td>
        <td>{formatCurrencySEK(parseInt(calcUtd[0]),true,false)}</td>
        <td>{calcOdds[0].toLocaleString('sv-SE', {maximumFractionDigits: 0})}</td>
      </tr>
      <tr>
        <td>Median</td>
        <td>{formatCurrencySEK(parseInt(calcUtd[1]),true,false)}</td>
        <td>{calcOdds[1].toLocaleString('sv-SE', {maximumFractionDigits: 0})}</td>
      </tr>
      <tr>
        <td>Max</td>
        <td>{formatCurrencySEK(parseInt(calcUtd[2]),true,false)}</td>
        <td>{calcOdds[2].toLocaleString('sv-SE', {maximumFractionDigits: 0})}</td>
      </tr>
    </table>
  </div>
    <div class="break"></div>
    <div class="item">
        <table>
          <thead>
            <tr>
              <th></th>
              <th style="text-align:left;">Match</th>
              <th>1</th>
              <th>X</th>
              <th>2</th>
            </tr>
          </thead>
          {#each $matches as {
            Nr,
            Match, 
          }, rowIndex}
          <tr>
            <td style="text-align:right;">{Nr}</td>
            <td style="text-align:left;">{Match}</td>
            <td class="progress-cell {!enableCharDist ? `gr${v1[rowIndex]}` : ''}">
              {#if enableCharDist == true}
                <div class="progress-bar gr{v1[rowIndex]}" style="width: {(distribution1X2[rowIndex].f1*100).toFixed(0) + '%'}"></div>
                <span class="progress-label">
                  {#if distribution1X2[rowIndex].f1 > 0}
                   {(distribution1X2[rowIndex].f1*100).toFixed(0)}%
                 {/if}
                </span>
              {/if}
            </td>
            <td class="progress-cell {!enableCharDist ? `gr${vX[rowIndex]}` : ''}">
              {#if enableCharDist == true}
                <div class="progress-bar gr{vX[rowIndex]}" style="width: {(distribution1X2[rowIndex].fX*100).toFixed(0) + '%'}"></div>
                <span class="progress-label">
                  {#if distribution1X2[rowIndex].fX > 0}
                    {(distribution1X2[rowIndex].fX*100).toFixed(0)}%
                  {/if}
                </span>
             {/if}
            </td>
            <td class="progress-cell {!enableCharDist ? `gr${v2[rowIndex]}` : ''}">
              {#if enableCharDist == true}
                <div class="progress-bar gr{v2[rowIndex]}" style="width: {(distribution1X2[rowIndex].f2*100).toFixed(0) + '%'}"></div>
                <span class="progress-label">
                  {#if distribution1X2[rowIndex].f2 > 0}
                    {(distribution1X2[rowIndex].f2*100).toFixed(0)}%
                  {/if}
                </span>
              {/if}
            </td>        
          </tr>
          {/each}
        </table>
      </div>
      <div class="break"></div>
<div class="groupButtons item">
  {#each groups as group, index}
    {#if index > 0 && index < 5 && group.active == "1" }
      <button
        class="colorTab gr{group.id} active{group.active}">
        <!-- {group.name} -->
        {#if group.active == "1"}
              {group.minMax[0]}<img src="/images/minmax.svg" alt="MinMax" title="Min Max" class="active" />{group.minMax[1]}
        {:else if group.active == "0"}
          <img src="/images/minmax.svg" alt="MinMax" title="Min Max" class="inactive" />
        {/if}
      </button>
    {/if}
  {/each}

  {#each groups as group, index}
    {#if index == 0 && group.active == "1"}
      <button
        class="colorTab gr{group.id} active{group.active}">
        <!-- {group.name} -->
        {#if groups[5].minMax[0] > 0 || groups[5].minMax[1] < groups[5].max}
        <span class="smallPill1X2">
          {groups[5].minMax[0]}<img src="/images/minmax1.svg" alt="MinMax1" title="Min Max 1" class="active1X2" />{groups[5].minMax[1]}
        </span>
        {/if}
        {#if groups[6].minMax[0] > 0 || groups[6].minMax[1] < groups[6].max}
        <span class="smallPill1X2">
          {groups[6].minMax[0]}<img src="/images/minmaxX.svg" alt="MinMaxX" title="Min Max X" class="active1X2" />{groups[6].minMax[1]}
        </span>
        {/if}
        {#if groups[7].minMax[0] > 0 || groups[7].minMax[1] < groups[7].max}
        <span class="smallPill1X2">
          {groups[7].minMax[0]}<img src="/images/minmax2.svg" alt="MinMax2" title="Min Max 2" class="active1X2" />{groups[7].minMax[1]}
        </span>
        {/if}
        {#if group.active == "0"}
        <img src="/images/minmax.svg" alt="MinMax" title="Min Max" class="inactive" />
        {/if}
        </button>
    {/if}
  {/each}
</div>

  <div class="break"></div>
  <div class="item">
    {#if message}
    <p>{message}</p>
    {/if}
  </div>

    <div class="screenshot" bind:this={tableContainer}>
      <div class="couponImage">
        <table>
          <thead>
            <tr>
              <th><img src="/images/gc-logo-horizontal.png" style="height:15px;"></th>
              <th style="text-align:left;">Match</th>
              <th>1</th>
              <th>X</th>
              <th>2</th>
            </tr>
          </thead>
          {#each $matches as {
            Nr,
            Match, 
          }, rowIndex}
          <tr>
            <td style="text-align:right;">{Nr}</td>
            <td style="text-align:left;">{Match}</td>
            <td class="gr{v1[rowIndex]} progress-cell" style="width:25px;">&nbsp;</td>
            <td class="gr{vX[rowIndex]} progress-cell" style="width:25px;">&nbsp;</td>
            <td class="gr{v2[rowIndex]} progress-cell" style="width:25px;">&nbsp;</td>        
          </tr>
          {/each}
        </table>
      </div>
<div class="groupButtons">
  {#each groups as group, index}
    {#if index > 0 && index < 5 && group.active == "1" }
      <button
        class="colorTab gr{group.id} active{group.active}">
        <!-- {group.name} -->
        {#if group.active == "1"}
              Min: {group.minMax[0]} Max: {group.minMax[1]}
        {:else if group.active == "0"}
          <img src="/images/minmax.svg" alt="MinMax" title="Min Max" class="inactive" />
        {/if}
      </button>
    {/if}
  {/each}

  {#each groups as group, index}
    {#if index == 0 && group.active == "1"}
      <button
        class="colorTab gr{group.id} active{group.active}">
        <!-- {group.name} -->
        {#if groups[5].minMax[0] > 0 || groups[5].minMax[1] < groups[5].max}
        <span class="smallPill1X2">
          1 - Min: {groups[5].minMax[0]} Max: {groups[5].minMax[1]}
        </span>
        {/if}
        {#if groups[6].minMax[0] > 0 || groups[6].minMax[1] < groups[6].max}
        <span class="smallPill1X2">
          X - Min: {groups[6].minMax[0]} Max: {groups[6].minMax[1]}
        </span>
        {/if}
        {#if groups[7].minMax[0] > 0 || groups[7].minMax[1] < groups[7].max}
        <span class="smallPill1X2">
          2 - Min: {groups[7].minMax[0]} Max: {groups[7].minMax[1]}
        </span>
        {/if}
        {#if group.active == "0"}
        <img src="/images/minmax.svg" alt="MinMax" title="Min Max" class="inactive" />
        {/if}
        </button>
    {/if}
  {/each}
</div>

 <div class="break"></div>
{#if parseInt(antalReduceradeRader) === antalTecken[3]}
<div class="couponValue">
  {formatCurrencySEK(parseInt(antalReduceradeRader),true,false)}
  {#if insats > 1}
    (x{insats})
  {/if}
</div>
{:else}
<div class="couponValue">
  {formatCurrencySEK(parseInt(antalReduceradeRader),true,false)}
  {#if insats > 1}
    (x{insats})
  {/if}
  </div>
  <div class="break"></div>
    <div class="couponValueSmall">
      Reducerat med { ((1 - parseInt(antalReduceradeRader) / antalTecken[3]) * 100).toFixed(1)}%
      (ursprungligen {formatCurrencySEK(antalTecken[3],true,false)})
    </div> 
{/if}
<!--- Omsättning -->
{#if utd[0] === 1}
    <table class="calcUtdOdds">
      <tr>
        <th>Utdelning Min</th>
        <th>Utdelning Max</th>
      </tr>
      <tr>
        <td>{formatCurrencySEK(utd[1])}</td>
        <td>{formatCurrencySEK(utd[2])}</td>
      </tr>
    </table>
{/if}
<!-- -->
    </div>


  </div>
{/if}

{#if activeTab === 1}
  <div class="content-area">
    <div class="item">
      <HistogramChart {data} />
    </div>
    <div class="break"></div>
    <div class="item">
      {tabs[1].info}
    </div>

  </div>
{/if}

<!-- {#if activeTab === 2}
  <div class="content-area">
    <div class="item">
      <input 
        type="checkbox" 
        bind:checked={enableCharDist}
      /> Visa teckenfördelning
        <table>
          <thead>
            <tr>
              <th></th>
              <th style="text-align:left;">Match</th>
              <th>1</th>
              <th>X</th>
              <th>2</th>
            </tr>
          </thead>
          {#each $matches as {
            Nr,
            Match, 
          }, rowIndex}
          <tr>
            <td style="text-align:right;">{Nr}</td>
            <td style="text-align:left;">{Match}</td>
            <td 
              class="progress-cell {!enableCharDist ? `gr${v1[rowIndex]}` : ''}"
              style="width:25px;"
            >
              {#if enableCharDist == true}
                <div class="progress-bar gr{v1[rowIndex]}" style="width: {(distribution1X2[rowIndex].f1*100).toFixed(0) + '%'}"></div>
                <span class="progress-label">
                  {#if distribution1X2[rowIndex].f1 > 0}
                   {(distribution1X2[rowIndex].f1*100).toFixed(0)}%
                 {/if}
                </span>
              {/if}
            </td>
            <td 
              class="progress-cell {!enableCharDist ? `gr${vX[rowIndex]}` : ''}"
              style="width:25px;"
            >
              {#if enableCharDist == true}
                <div class="progress-bar gr{vX[rowIndex]}" style="width: {(distribution1X2[rowIndex].fX*100).toFixed(0) + '%'}"></div>
                <span class="progress-label">
                  {#if distribution1X2[rowIndex].fX > 0}
                    {(distribution1X2[rowIndex].fX*100).toFixed(0)}%
                  {/if}
                </span>
             {/if}
            </td>
            <td 
              class="progress-cell {!enableCharDist ? `gr${v2[rowIndex]}` : ''}"
              style="width:25px;"
            >
              {#if enableCharDist == true}
                <div class="progress-bar gr{v2[rowIndex]}" style="width: {(distribution1X2[rowIndex].f2*100).toFixed(0) + '%'}"></div>
                <span class="progress-label">
                  {#if distribution1X2[rowIndex].f2 > 0}
                    {(distribution1X2[rowIndex].f2*100).toFixed(0)}%
                  {/if}
                </span>
              {/if}
            </td>        
          </tr>
          {/each}
        </table>
      </div>
  </div>
{/if} -->

<!-- {#if activeTab === 3}
  <div class="content-area">

    <span>{$browser} • {$platform} • {$isPWAInstalled ? 'Using PWA' : 'Not using PWA'}</span>


<h1>Payload</h1>
    payload.v1 {payload.v1}<br />
    payload.vX {payload.vX}<br />
    payload.v2 {payload.v2}<br />
    payload.antT[0] {payload.antT[0]}<br />
    payload.antT[1] {payload.antT[1]}<br />
    payload.antT[2] {payload.antT[2]}<br />
    payload.antT[3] {payload.antT[3]}<br />
    payload.antT[4] {payload.antT[4]}<br />
    payload.antT[5] {payload.antT[5]}<br />
    payload.antT[6] {payload.antT[6]}<br />
    payload.utd[0] {payload.utd[0]}<br />
    payload.utd[1] {payload.utd[1]}<br />
    payload.utd[2] {payload.utd[2]}<br />
    payload.yellow[0] {payload.yellow[0]}<br />
    payload.yellow[1] {payload.yellow[1]}<br />
    payload.yellow[2] {payload.yellow[2]}<br />
    payload.green[0] {payload.green[0]}<br />
    payload.green[1] {payload.green[1]}<br />
    payload.green[2] {payload.green[2]}<br />
    payload.red[0] {payload.red[0]}<br />
    payload.red[1] {payload.red[1]}<br />
    payload.red[2] {payload.red[2]}<br />
    payload.pink[0] {payload.pink[0]}<br />
    payload.pink[1] {payload.pink[1]}<br />
    payload.pink[2] {payload.pink[2]}

<h1>Response</h1>
    {#if response}
    response.antalReduceradeRader {response.antalReduceradeRader}<br />
    response.maxOdds {response.maxOdds}<br />
    response.maxUtd {response.maxUtd}<br />
    response.medianOdds {response.medianOdds}<br />
    response.medianUtd {response.medianUtd}<br />
    response.minOdds {response.minOdds}<br />
    response.minUtd {response.minUtd}<br />
    response.svsLink {response.svsLink}<br />
    response.histogram {response.histogram}
    {/if}
  </div>
{/if} -->




<!-- {#each $matches as {
        Nr,
        Match}, rowIndex}
{Match} {v1[rowIndex]} <br />

{/each} -->

<div class="sendCoupon">

  <div class="couponCharDist">
<label class="switch">
  <input type="checkbox" bind:checked={enableCharDist}>
  <span class="slider round"></span>
</label>
 Teckenfördelning
</div>

 <div class="break"></div>
{#if parseInt(antalReduceradeRader) === antalTecken[3]}
<div class="couponValue">
  {formatCurrencySEK(parseInt(antalReduceradeRader),true,false)}
  {#if insats > 1}
    (x{insats})
  {/if}
</div>
{:else}
<div class="couponValue">
  {formatCurrencySEK(parseInt(antalReduceradeRader),true,false)}
  {#if insats > 1}
    (x{insats})
  {/if}
  </div>
  <div class="break"></div>
    <div class="couponValueSmall">
      Reducerat med { ((1 - parseInt(antalReduceradeRader) / antalTecken[3]) * 100).toFixed(1)}%
      (ursprungligen {formatCurrencySEK(antalTecken[3],true,false)})
    </div> 
{/if}


<div class="break"></div>

    <button 
      class="noBG"
      on:click={copyTableAsImage}
    >
      <img src="/images/imageCopy.svg" height="26pt" alt="test" />  
    </button>

    <button 
      class="noBG"
      on:click={captureAndUpload}
    >
      <img src="/images/imageURL.svg" height="26pt" alt="test" />  
    </button>

<!--     <button 
      class="noBG"
      on:click={downloadTableAsImage}
    >
      D
    </button> -->

    <button on:click={openSvSLink}>
    
      Lämna in spel
  
    </button>

    <button 
      class="noBG"
      on:click={copyTableAsImage}
      disabled
    >
      <img src="/images/copyURL.svg" height="26pt" alt="test" />  
    </button>
    <button 
      class="noBG"
      on:click={() => showLiveModal = true}
    >
      <img src="/images/saveLive.svg" height="26pt" alt="test" />  
    </button>


  <div class="break"></div>

  <!-- <p class="small">OBS! Addblockers behöver stängas av för att komma vidare till Svenska Spel</p> -->
  <p class="small">OBS! Stäng av Addblockers för att komma vidare till Svenska Spel</p>
</div>

{/if}
</div>


<LiveModal 
  bind:submittedLive={submittedLive} 
  {handleSubmitLive}
  {responseLive}
  {antalReduceradeRader}
  showModal={showLiveModal} 
  on:close={() => showLiveModal = false}
/>

<style>

  .couponCharDist {
    flex: 1;
    font-size: 10pt;
    line-height: 1em;
    font-weight: 300;
    margin: 0;
    padding: 0;    
  }


  .couponValue {
    flex: 1;
    font-size: 24pt;
    line-height: 1em;
    font-weight: 900;
    margin: 0;
    padding: 0;
  }

  .couponValueSmall {
    flex: 1;
    font-size: 10pt;
    font-weight: 400;
    margin: 0;
    padding: 0;
  }

  .sendCoupon {
/*     border: 1px solid red; */
    display: flex;
    flex-wrap: wrap;
    height: 105pt;
    width: 100%;
    text-align: center;
    padding: 0 0 5pt 0;
    position: fixed;
    bottom: 0;
    left: 0;
    overflow: hidden;
    margin: 0;
  }

  .sendCoupon button {
    flex: 4;
    height: 40pt;
/*     margin: auto; */
    vertical-align: text-top;
    background-color: var(--themeColor1);
    color: var(--themeColorText);
    border-radius: 20pt;
    border: 4pt double var(--themeColorText);
    margin: 0;
    cursor: pointer;
  }

  .sendCoupon button.noBG {
    flex: 1;
    color: var(--themeColor1);
    background: none;
    cursor: pointer;
    border: none;
  }

  .sendCoupon button.noBG:disabled {
    filter: opacity(35%);
  }  

  button.noBG img {
    filter: var(--themeColorFill2);
  }

  .sendCoupon p.small {
    flex: 1;
    margin: 0;
    padding: 0;
    font-size: 10pt;
/*     border: 1px solid blue; */
  }


/* 	button:active {
	 background: none;
	} */

  .tab-component {
    display: flex;
    flex-direction: column;
    height: calc(100dvh - 230pt);
    overflow: hidden;
    flex: 1;
    display: flex;
  }

  .tab-container {
    display: flex;
    position: relative;
    height: 40pt;
    background-color: var(--themeColor1);
    border-radius: 20pt;
    padding: 5pt;
  }

  .tab {
    flex: 1;
    color: var(--themeColorText);
    padding: 8pt;
    border: none;
    background: none;
    cursor: pointer;
    position: relative;
    z-index: 1;
    transition: color 0.3s;
    cursor: pointer;
  }

  .tab.active {
    color: var(--themeColor1);
  }

  .popOverInfo {
    background-color: white !important;
    border: 2pt solid var(--themeColor1);
    max-width: 200pt;
    padding: 10pt;
    margin: 0;
    border-radius: 10pt;
  }

  .pill {
    position: absolute;
    height: 30pt;
    background-color: var(--themeColorText);
    border-radius: 15pt;
    transition: width 0.3s;
/*     top: 5px; */
  }

  .content-area {
    display: flex;
    flex-wrap: wrap;
    justify-content: center; /* Centers horizontally */
    align-items: center; /* Centers vertically */
/*     background-color: #f9f9f9; */
    border-radius: 10pt;
    padding: 20pt;
    min-height: 100pt;
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    max-width: 863px;
    max-height: none;
    max-width: none;

  }

  .item {
    /* Assuming you want each item to take up a certain width before wrapping */
    flex: 1 1 calc(50% - 10px); /* Example: two items per row with some margin */
/*     margin: 5px;  */
    /* For some space between items */
  }

  .break {
    flex-basis: 100%;
    height: 0;
    /* Optionally, if you don't want it to affect layout visually */
    margin: 0;
    padding: 0;
  }

  .screenshot {
    width: auto;
    padding: 0;
    position: absolute;
    left: -9999px;
    top: -9999px;    
  }

  .couponImage {

  }

  .couponImage table {
    border-spacing: 0;
    margin: auto;
    border:2pt solid var(--themeColor1);
    border-radius:10pt;
    width: 100%;
    max-width: 680px;
  }

  .couponImage th {
    background-color:var(--themeColor1);
    color:var(--themeColorText);
  }

  .couponImage td {
    border-top: 1pt solid var(--themeColor1);
    min-width: 50px;
    padding: 2pt;
  }

  .couponImage th:first-child {
    border-radius: 7pt 0 0 0;
  }

  .couponImage th:last-child {
    border-radius: 0 7pt 0 0;
  }

  .couponImage tr:last-child td:first-child {
    border-radius: 0 0 0 7pt;
  }

/*   tr:last-child td {
    border-bottom: none;
  } */

  .couponImage tr:last-child td:last-child {
    border-radius: 0 0 7pt 0;
  }

  table {
    border-spacing: 0;
    margin: auto;
    border:2pt solid var(--themeColor1);
    border: none;
    width: 100%;
    max-width: 680px;
  }

  table th {
/*     background-color: #f9f9f9; */
    color:var(--themeColor1);
    padding: 4pt;
  }

  table th img {
    filter: var(--themeColorFill2);
    vertical-align: text-top;
    height: 12pt;
  }

  table td {
    border: none;
  }

  table tr td {
    border-bottom: 2px solid var(--themeColor1);
  }

  table tr:last-child td {
    border-bottom: none;
  }

  table tr td.progress-label, table tr td.progress-cell {
    border-left: 2px solid var(--themeColor1);
  }


.colorTab {
  flex: 1 1 auto;
  min-width: 0;
/*   cursor: pointer; */
  display: inline-block;
  height: 25pt;
  font-size: 12pt;
/*   padding-bottom: 28pt; */
  transition: flex 0.3s ease;
  border-radius: 15pt;
  margin: 0 1pt 2pt 1pt;
  padding: 0;
/*   box-shadow: rgba(255, 255, 255, 0.15) 0px 3px 3px 0px; */
/*   margin-bottom: 0px; */
}

.gr2 img, .gr5 img {
  filter: invert(100%);
}

span.smallPill1X2 {
  background-color: rgba(255,255,255,0.2);
  padding: 1pt 4pt 1pt 4pt;
  border-radius: 10pt;
}

.groupButtons {
  flex: 1;
  display: flex;
/*   align-items: end; */
  padding: 0;
  transition: opacity 0.3s ease-in-out;
/*     overflow-x: scroll; */
/*   background-color: rgba(255,255,255,0.2);
  border-radius: 20pt;
  padding: 3pt; */
/*   border: 2px solid red; */
/*   background-color: var(--color-1); */
}

.groupButtons button {
/*   filter: opacity(85%); */
  border: 2pt solid whitesmoke;
  padding-bottom: 0;
  margin-bottom: 0;
}

.groupButtons button img.active {
  height: 8pt;
  padding: 0 2pt 0 2pt;
/*   margin-top: 4pt;   */
}

.groupButtons button img.active1X2 {
  height: 12pt;
  padding: 0 2pt 0 2pt;
  vertical-align: text-top;
  margin-top: 1.5pt;
}


 /*  table.calcUtdOdds tr:last-child td:last-child, table.calcUtdOdds tr:last-child td:first-child, table.calcUtdOdds th:first-child, table.calcUtdOdds th:last-child {

  } */

    .progress-cell {
        width: 50px;
        position: relative;
        overflow: hidden;
        text-align: center; /* Center the text */
    }
    
    .progress-bar {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
    }
    
    .progress-label {
        position: relative; /* This ensures the label appears on top */
        z-index: 1; /* Higher z-index to appear above the progress bar */
        font-size: 9pt;
        text-shadow: 1px 0 #fff, -1px 0 #fff, 0 1px #fff, 0 -1px #fff,
             1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;
    }

  .loading-screen {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 9999;
  }

  .spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid var(--themeColor1);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }


.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
  vertical-align: text-top;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .2s;
  transition: .2s;
}

input:checked + .slider {
  background-color: var(--themeColor1);
}

input:focus + .slider {
  box-shadow: 0 0 1px var(--themeColor1);
}

input:checked + .slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 17px;
}

.slider.round:before {
  border-radius: 50%;
}


  @media (max-width: 768px) {
    .content-area {
      border-radius: 10px;
      padding: 0;
      min-height: 100px;
      flex-grow: 1;
      overflow-y: auto;
      overflow-x: hidden;
      width: 100%;
/*       max-width: 863px; */
      max-height: none;
    }

    table {
      font-size: 10pt;
      width: 100%;
/*       max-width: 680px; */
    }


    .sendCoupon {
/*       height: 65pt; */
    }

    .sendCoupon p.small {
      font-size: 8pt;
    }



  }


</style>